









































































































































import { Component, Vue, Emit, Ref } from 'vue-property-decorator'
import { Services, Apis, Factories } from '@finx/web-repository'
import moment from 'moment'
import { Producao } from '@/types/_'
import ProducaoVuex from '@/store/ProducaoVuex'
// import Producao from '@finx/web-repository/src/apis/Legacy/services/Producao'

@Component

export default class ViewProducao extends Vue {
  loading: any = {
    status: false,
    text: 'Carregando...',
  }

  snackbar: any = {
    disabled: true,
    message: 'Nova informação registrada pela equipe.',
    show: false,
    timeout: 60000,
  }

  dialog: Boolean = false
  isContratoPlantao: boolean = false
  panel: String = ''
  textfield: String = ''
  show: Boolean = false
  tRevisar: Number = 0
  producoes: Producao[] = []
  resultProducaoMsg: boolean = false
  revisarProducaoFiltro: boolean = true
  enabledBtnRevisao: boolean = true
  lock: Boolean = false
  filtrarRules: Boolean = false

  statusOptions: [] = []
  loadingStatus: boolean = false


  ga(event: string, action: string) {
    this.$ga.event(event, action, this.$user.profile.email)
  }

  get getResultProducaoMsg() {
    return this.resultProducaoMsg
  }

  set getResultProducaoMsg(value) {
    this.resultProducaoMsg = value
  }

  get getProducoes() {
    return this.producoes
  }

  set getProducoes(value) {
    this.producoes = value
  }

  set showProducaoFiltro(value) {
    ProducaoVuex.commit('SET_SHOW_PRODUTO_FILTRO', value)
  }

  get showProducaoFiltro() {
    return ProducaoVuex.getters.SHOW_PRODUTO_FILTRO
  }

  get iconeBotaoFiltros(): string {
    if (this.showProducaoFiltro) {
      return 'close'
    }
    return 'search'
  }

  get qtdFiltrosListagem(): number {
    let count = 0
    const filter = this.produtoFiltro
    if (filter.fontePagadoraId) count++
    if (filter.localExecucaoId) count++
    if (filter.pacienteId) count++
    if (filter.medicoId) count++
    if (filter.procedimento) count++
    if (filter.periodo && (filter.periodo.start || filter.periodo.end)) count++
    return count
  }

  get temFiltroListagemAtivo(): boolean {
    return this.qtdFiltrosListagem > 0
  }

  set statusFiltro(value) {
    this.$ga.event('producao', 'filtro-producao-status', this.$user.profile.email)
    ProducaoVuex.commit('SET_PAGE', 1)
    ProducaoVuex.commit('SET_STATUS_FILTRO', value)
    this.getProducoes = []
    this.getList()
    this.getTotalPages()
  }

  get statusFiltro() {
    return ProducaoVuex.getters.STATUS_FILTRO
  }

  get items() {
    return null
  }

  get produtoFiltro() {
    return ProducaoVuex.getters.PRODUTO_FILTRO
  }

  get totalRevisar() {
    return ProducaoVuex.getters.TOTAL_REVISAO
  }

  set totalRevisar(value) {
    ProducaoVuex.commit('SET_TOTAL_REVISAO', value)
  }

  get getRevisarProducaoFiltro() {
    return this.revisarProducaoFiltro
  }

  set getRevisarProducaoFiltro(value) {
    this.revisarProducaoFiltro = value
  }

  get getPage(): number {
    return ProducaoVuex.getters.PAGE
  }

  set getPage(value) {
    ProducaoVuex.commit('SET_PAGE', value)
  }

  get bloquearGestao(): boolean {
    return ProducaoVuex.getters.BLOQUEAR_GESTAO
  }

  set bloquearGestao(value) {
    ProducaoVuex.commit('SET_BLOQUEAR_GESTAO', value)
  }

  get totalPages(): number {
    return ProducaoVuex.getters.TOTAL_PAGES
  }

  set totalPages(value) {
    ProducaoVuex.commit('SET_TOTAL_PAGES', value)
  }

  get getEnabledBtnRevisao() {
    return this.enabledBtnRevisao
  }

  set getEnabledBtnRevisao(value) {
    this.getProducoes = []
    this.getRevisar()
    this.enabledBtnRevisao = value
  }

  get getIsContratoPlantao() {
    return this.isContratoPlantao
  }

  set getIsContratoPlantao(value) {
    this.isContratoPlantao = value
  }

  redirectPage() {
    if (this.getIsContratoPlantao) {
      this.redirect('/plantao')
    } else {
      this.redirect('/provisao')
    }
  }

  async closeSnackbar() {
    this.snackbar.show = false
    this.getPage = 1
    this.getProducoes = []
    await this.loadScrollPages()
  }

  async contratoPlantaoLoad() {
    const request = await Apis.Contratos.Contrato.isContratoPlantao()
    const success = Factories.Apis.success(request)

    if (success) {
      this.getIsContratoPlantao = request.data as boolean
    }
  }

  async getList() {
    ProducaoVuex.commit('SET_PAGE', 1)
    this.getProducoes = []
    
    this.loading.status = true
    this.loading.text = 'Carregando...'

    try {
      const request = await Apis.Legacy.Producao.getProducaoList(this.produtoFiltro)
      const success = Factories.Apis.success(request)
      if (success && request.data !== '') {
        this.getProducoes = request.data.producoes
        this.bloquearGestao = request.data.bloquearGestao
        this.totalRevisar = request.data.totalAguardandoRevisao

        if (success) {
          if (request.data !== '' || request.data.length > 0) {
            this.getProducoes = request.data.producoes
            this.totalRevisar = request.data.totalAguardandoRevisao

            if (request.data.producoes.length > 0) {
              this.getPage = this.getPage + 1
            }
          }
        }
      }

      this.enableResultProducaoMsg(request)
    } finally {
      this.loading.status = false
    }
    
    this.ga('producao-financeiro', 'filtro-listar-producao')
  }

  async getTotalPages() {
    try {
      const request = await Apis.Legacy.Producao.getProducaoTotalPages(this.produtoFiltro)
      const success = Factories.Apis.success(request)
      if (success && request.data !== '') {
        this.totalPages = request.data.totalPages

        if (success) {
          if (request.data !== '' || request.data.length > 0) {
            this.totalPages = request.data.totalPages
            this.filtrarRules = true
          }
        }
      }

      this.enableResultProducaoMsg(request)
    } finally {
      this.loading.status = false
    }
  }

  get getLock() {
    return this.lock
  }

  set getLock(value) {
    this.lock = value
  }

  async loadScrollPages() {
    this.getLock = true
    this.loading.status = true
    this.loading.text = 'Carregando...'
    
    try {
      const request = await Apis.Legacy.Producao.getProducaoList(this.produtoFiltro)
      const success = Factories.Apis.success(request)

      if (success) {
        if (request.data && request.data.producoes && request.data.producoes.length > 0) {
          request.data.producoes.map(c => this.getProducoes.push(c))

          this.totalRevisar = request.data.totalAguardandoRevisao
          this.getPage = this.getPage + 1
          this.totalPages = request.data.totalPages
        }
      }

      this.enableResultProducaoMsg(request)
    } finally {
      this.loading.status = false
      this.getLock = false
    }
  }

  redirectDashboard() {
    ProducaoVuex.commit('SET_PAGE', 1)
    this.redirect('/dashboard')
  }

  alertDialog(loading) {
    this.loading.status = loading.status
    this.loading.text = loading.text
  }

  scrollTrigger() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          if (this.getProducoes.length > 0) {
            if (!this.getLock) {
              this.loadScrollPages()
            }
          }
        }
      })
    })

    const infiniteScroll: any = this.$refs.infinitescrolltrigger
    observer.observe(infiniteScroll as Element)
  }

  enableResultProducaoMsg(request) {
    if (this.getPage <= 1 && (request.data === '' || request.data.length === 0 || request.data.producoes.length === 0)) {
      this.getResultProducaoMsg = true
    } else {
      this.getResultProducaoMsg = false
    }
  }

  clearFields() {
    ProducaoVuex.commit('RESET_PRODUTO_FILTRO')
  }

  async created() {
    this.clearFields()

    await this.getList()
    await this.getTotalPages()
    await this.getUser()
  }

  async getRevisar() {
    this.getRevisarProducaoFiltro = !this.getRevisarProducaoFiltro
    ProducaoVuex.commit('SET_AGUARDANDO_REVISAO', this.getRevisarProducaoFiltro)
    ProducaoVuex.commit('SET_PAGE', 1)
    await this.getList()
  }

  async getUser() {
    ProducaoVuex.commit('SET_USER', this.$user.profile)
  }

  async getStatusOptions() {
    this.loadingStatus = true
    const request = await Apis.Legacy.Producao.getProducaoStatus(this.produtoFiltro)
    const success = Factories.Apis.success(request)
    if (success) {
      this.statusOptions = request.data
    }
    this.loadingStatus = false
  }

  async mounted() {
    this.scrollTrigger()
    await this.contratoPlantaoLoad()
    await this.getStatusOptions()
    const { filtro }: any = this.$refs
    if (filtro) {
      filtro.loadSelectAll()
    }
  }

  redirect(url): void {
    this.$router.push(url)
  }
}
